<div class="sh-headpanel-right">
  <!-- <app-notifications></app-notifications> -->
  <app-profile-options [profileBtns]="profileDdwnBtns"></app-profile-options>
</div>
